<template>
	<v-row class="mx-1 my-7">
		<slot name="meta" />

		<v-col v-if="contentData?.title" cols="12">
			<h3 class="q-title text-center">{{ contentData.title }}</h3>
		</v-col>
		<div v-if="contentData?.text" v-html="contentData.text" class="full-width" />

		<slot name="Checkout">
			<template v-if="contentData?.includeCheckout && !hasStatus">
				<div v-if="contentData?.checkoutDescription" v-html="contentData.checkoutDescription" class="full-width" />
				<div class="full-width text-center">
					<v-btn v-if="!hasCheckout" color="primary" @click="hasCheckout = true">{{ contentData.ctaButtonLabel }}</v-btn>
					<StripeCheckoutEmbedded
						v-if="sessionData && hasCheckout"
						:session-data="sessionData"
						:edit-mode="editMode"
					/>
				</div>
			</template>
		</slot>

		<slot name="CheckoutReturn">
			<template v-if="contentData?.includeCheckoutReturn && hasStatus">
				<div v-if="contentData?.checkoutReturnDescription" v-html="contentData.checkoutReturnDescription" class="full-width" />
				<div class="full-width">
					<StripeCheckoutEmbeddedReturn>
						<template #complete="{ status }">
							<v-alert type="success" text outlined class="my-4">
								<div>Stripe's Session Status: <strong>{{ status }}</strong></div>
							</v-alert>
							<div v-html="contentData.completeStatusText" />
						</template>

						<template #incomplete="{ status }">
							<v-alert type="info" text outlined class="my-4">
								<div>Stripe's Session Status: <strong>{{ status }}</strong></div>
							</v-alert>
							<div v-html="contentData.incompleteStatusText" />
							<div v-if="contentData.includeTryAgainButton" class="full-width text-center">
								<v-btn color="primary" @click="tryAgain">{{ contentData.tryAgainButtonLabel }}</v-btn>
							</div>
						</template>
					</StripeCheckoutEmbeddedReturn>
				</div>
			</template>
		</slot>
	</v-row>
</template>

<script>
import StripeCheckoutEmbedded from '@/plugins/stripe/StripeCheckoutEmbedded.vue'
import StripeCheckoutEmbeddedReturn from '@/plugins/stripe/StripeCheckoutEmbeddedReturn.vue'

const fields = [
	'mode',
	'return_url',
	'line_items',
]

export default {
    name: 'StripeCheckout',
	components: {
		StripeCheckoutEmbedded,
		StripeCheckoutEmbeddedReturn,
	},
    props: {
        contentData: { type: Object },
        editMode: { type: Boolean, default: false },
    },
	data () {
		return {
			hasCheckout: false,
			hasStatus: false,
		}
	},
	computed: {
		sessionData () {
			if (!this.contentData) { return undefined }
			return fields.reduce((acc, field) => {
				acc[field] = this.contentData?.[field]
				return acc
			}, {})
		},
	},
	watch: {
		contentData: {
			deep: true,
			handler () {
				this.hasCheckout = false
			},
		},
		'$route.query': {
			immediate: true,
			handler () {
				this.checkSessionStatus()
			},
		},
	},
	methods: {
		checkSessionStatus () {
			this.hasStatus = !!this.$route.query?.session_id
			if (this.hasStatus) {
				this.hasCheckout = true
			}
		},
		tryAgain () {
			this.hasStatus = false
			this.hasCheckout = false
			this.removeSessionIdParam()
		},
		removeSessionIdParam () {
			const { session_id, ...query } = this.$route.query
			this.$router.replace({ query })
		},
	},
}
</script>
